let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SJXV")).then(() => parcelRequire('fW86E'));